export default "__VITE_ASSET__DV$$0S4N__"